import React, { useState, useEffect, useRef, useContext } from "react";
import { AuthContext } from "../../../context/auth.context";
import LeftSideItemWrapper from "./LeftSideItemWrapper";
import LeftSideItemContent from "./LeftSideItemContent";
import cn from "classnames";
import styles from "./LeftSideItem.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";

function LeftSideItemFooter({
    item,
    displayText,
    isChild,
    isBalance,
    isNotify,
    isLogout,
    setActiveRouteName,
    activeRouteName,
    onForceClose,
    isExpand
}) {

    const { logout } = useContext(AuthContext);
    const navigate = useNavigate();
    const hasChildren = !!(item.children && item.children.length);
    const [displayChildren, setDisplayChildren] = useState(false);
    const titleRef = useRef(null);
    const [supportModal, setSupportModal] = useState(false)

    const goTo = (e, link) => {
        if (!hasChildren || !isExpand) {
            setActiveRouteName(link)
            onForceClose(false)
            return
        }

        e.preventDefault()
        e.stopPropagation()
        setDisplayChildren(!displayChildren);
    };
    const closeDropdown = () => {
        setDisplayChildren(false);
    };

    const handleLogout = event => {
        event.preventDefault()
        event.stopPropagation()
        logout();
        navigate("/login", { replace: true });
    };

    return (
        <Link
            className={cn(
                styles["navigation-item__link"],
                {
                    ['justify-content-center']: !displayText,
                    [styles.active]: displayText && displayChildren || activeRouteName === item.link,
                }
            )}
            style={{width:"100%"}}

            to={item.link || '/'}
            onClick={e => goTo(e, item.link)}
        >
            <div className={cn(styles["navigation-footer__content"],)}>
                <div className={cn(styles["navigation-item__avatar"])}>
                    <div className={cn("m-0 p-0", styles['navigation-item__icon'])}>
                        {item.icon}
                    </div>
                    <div className={cn(styles["navigation-footer__text"])}>
                        <div ref={titleRef} className={cn(styles["navigation-footer__title"])}>
                            {item.title}
                        </div>
                        <span className={styles["navigation-item__bin"]}> 
                            БИН {item?.bin}
                        </span>
                    </div>
                </div>

                {isLogout && (
                    // <img src={<LogOut />} alt="exit" width="20px" height="20px" onClick={handleLogout} />
                    <LogOut  onClick={handleLogout} />
                )}
            </div>
        </Link>
    );
}


export default LeftSideItemFooter;
